import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/reporteestudianteplat',
    name: 'reporteestudianteplat',
    component: () => import('../components/ReporteEstudiantesPlat.vue')
  },
  {
    path: '/reportetestvocacionalsede',
    name: 'reportetestvocacionalsede',
    component: () => import('../components/ReporteTestVocacional/ReportePorSede.vue')
  },
  {
    path: '/reportetestvocacionalcolegio',
    name: 'reportetestvocacionalcolegio',
    component: () => import('../components/ReporteTestVocacional/ReportePorColegio.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/Login.vue')
  },
  {
    path: '/admision',
    name: 'admision',
    component: () => import('../components/Admision.vue')
  },
  {
    path: '/admisioncrmX',
    name: 'admisioncrmX',
    component: () => import('../components/AdminisionX.vue')
  },
  {
    path: '/admisioncrmami',
    name: 'admisioncrmami',
    component: () => import('../components/AdmisionAMI.vue')
  },
  {
    path: '/estudiantesnotasdeudas',
    name: 'estudiantesnotasdeudas',
    component: () => import('../components/RepEstnotasdeudas.vue')
  },
  {
    path: '/aula',
    name: 'aula',
    component: () => import('../components/Aula.vue')
  },
  {
    path: '/admisionact',
    name: 'admisionact',
    component: () => import('../components/Admision_act.vue')
  },
  {
    path: '/admisionval',
    name: 'admisionval',
    component: () => import('../components/Admision_val.vue')
  },
  {
    path: '/bloque',
    name: 'bloque',
    component: () => import('../components/Bloque.vue')
  },
  {
    path: '/pagos_call_libelula',
    name: 'pagos_call_libelula',
    component: () => import('../components/Pagos_callback_libelula.vue')
  },
  {
    path: '/carrera',
    name: 'carrera',
    component: () => import('../components/Carrera.vue')
  },
  {
    path: '/cole',
    name: 'cole',
    component: () => import('../components/Colegio.vue')
  },
  {
    path: '/colegiosami',
    name: 'colegiosami',
    component: () => import('../components/ColegiosAmi.vue')
  },
  {
    path: '/designaciondocentedac',
    name: 'designaciondocentedac',
    component: () => import('../components/DesignacionDocenteDAC.vue')
  },
  {
    path: '/documento',
    name: 'documento',
    component: () => import('../components/Documento.vue')
  },
  {
    path: '/gestionpla',
    name: 'gestionpla',
    component: () => import('../components/Gestionpla.vue')
  },
  {
    path: '/grupo',
    name: 'grupo',
    component: () => import('../components/Grupos.vue')
  },
  {
    path: '/reportessecretariageneral',
    name: 'repsecgral',
    component: () => import('../components/ReportesSGRAL.vue')
  },
  {
    path: '/grupocoord',
    name: 'grupocoord',
    component: () => import('../components/Grupos_coord.vue')
  },
  {
    path: '/grupodac',
    name: 'grupodac',
    component: () => import('../components/Grupos_dac.vue')
  },
  {
    path: '/tpcarrera',
    name: 'tpcarrera',
    component: () => import('../components/TipoCarrera.vue')
  },
  {
    path: '/tpplanestudio',
    name: 'tpplanestudio',
    component: () => import('../components/TipoPlanestudio.vue')
  },
  {
    path: '/tpmateria',
    name: 'tpmateria',
    component: () => import('../components/Tipo_materia.vue')
  },
  {
    path: '/repinfconvalidacion',
    name: 'repinfconvalidacion',
    component: () => import('../components/Rep_informesConv.vue')
  },
  {
    path: '/cambiacarreranuevos',
    name: 'cambiacarreranuevos',
    component: () => import('../components/Cambiacarreranuevos.vue')
  },
  {
    path: '/documentacion',
    name: 'documentacion',
    component: () => import('../components/Documentacion.vue')
  },
  {
    path: '/documentacioncrm',
    name: 'documentacioncrm',
    component: () => import('../components/Documentacioncrm.vue')
  },
  {
    path: '/repseguimientonuevos',
    name: 'repseguimientonuevos',
    component: () => import('../components/Repseguimientonuevos.vue')
  },
  {
    path: '/documenpost',
    name: 'documenpost',
    component: () => import('../components/Documento_post.vue')
  },
  {
    path: '/docentecv',
    name: 'docentecv',
    component: () => import('../components/Docente_cv.vue')
  },
  {
    path: '/docente',
    name: 'docente',
    component: () => import('../components/Docente.vue')
  },
  {
    path: '/materia',
    name: 'materia',
    component: () => import('../components/Materia.vue')
  },
  {
    path: '/nivel',
    name: 'nivel',
    component: () => import('../components/Nivel.vue')
  },
  {
    path: '/planestudio',
    name: 'planestudio',
    component: () => import('../components/Planestudio.vue')
  },
  {
    path: '/recibo',
    name: 'recibo',
    component: () => import('../components/Recibos.vue')
  },
  {
    path: '/anular',
    name: 'anular',
    component: () => import('../components/Anular.vue')
  },
  {
    path: '/prerequisito',
    name: 'prerequisito',
    component: () => import('../components/Prerequisito.vue')
  },
  {
    path: '/inscripcoor',
    name: 'inscripcoor',
    component: () => import('../components/Inscrip_coord.vue')
  },
  {
    path: '/inscripcoorx',
    name: 'inscripcoorx',
    component: () => import('../components/Inscrip_coordx.vue')
  },
  {
    path: '/designaciondocentenac',
    name: 'designaciondocentenac',
    component: () => import('../components/DesignacionDocenteNAC.vue')
  },
  {
    path: '/deudaest',
    name: 'deudaest',
    component: () => import('../components/Deuda_est.vue')
  },
  {
    path: '/repaulahr',
    name: 'repaulahr',
    component: () => import('../components/Rep_aula_hr.vue')
  },
  {
    path: '/repaulahrdac',
    name: 'repaulahrdac',
    component: () => import('../components/Rephrdac.vue')
  },
  {
    path: '/rephorariosnal',
    name: 'rephorariosnal',
    component: () => import('../components/RephrdacNal.vue')
  },
  {
    path: '/paralelo',
    name: 'paralelo',
    component: () => import('../components/Paralelo.vue')
  },
  {
    path: '/reporte1',
    name: 'reporte1',
    component: () => import('../components/Reporte1.vue')
  },
  {
    path: '/reporte3',
    name: 'reporte3',
    component: () => import('../components/Reporte3.vue')
  },
  {
    path: '/congresocertificados',
    name: 'congresocertificados',
    component: () => import('../components/CertificadoCongreso.vue')
  },
  {
    path: '/reporteseguro',
    name: 'reporteseguro',
    component: () => import('../components/Repseguros.vue')
  },
  {
    path: '/estudeupendientes',
    name: 'estudeupendientes',
    component: () => import('../components/Repestdeudapasada.vue')
  },
  {
    path: '/reportesfacturacion',
    name: 'reportesfacturacion',
    component: () => import('../components/Rep_facturacion.vue')
  },
  {
    path: '/reportescnaffacturacion',
    name: 'reportescnaffacturacion',
    component: () => import('../components/Rep_CNAFfacturacion.vue')
  },
  {
    path: '/reporte4',
    name: 'reporte4',
    component: () => import('../components/Reporte4.vue')
  },
  {
    path: '/reportepost1',
    name: 'reportepost1',
    component: () => import('../components/Repposcatsede.vue')
  },
  {
    path: '/reporcategoria',
    name: 'reporcategoria',
    component: () => import('../components/Repxcategoriasd.vue')
  },
  {
    path: '/reporte0',
    name: 'reporte0',
    component: () => import('../components/Reporte0.vue')
  },
  {
    path: '/tppostulante',
    name: 'tppostulante',
    component: () => import('../components/Tipo_postulante.vue')
  },
  {
    path: '/contradocente',
    name: 'contradocente',
    component: () => import('../components/Contrato_docente.vue')
  },
  {
    path: '/carnetestu',
    name: 'carnetestu',
    component: () => import('../components/Carnet_estu.vue')
  },
  {
    path: '/carnetplataforma',
    name: 'carnetplataforma',
    component: () => import('../components/Carnet_estu_plat.vue')
  },
  {
    path: '/docparampag',
    name: 'docparampag',
    component: () => import('../components/Docente_parametros_pagos.vue')
  },
  {
    path: '/calenacademico',
    name: 'calenacademico',
    component: () => import('../components/Calendario_academico.vue')
  },
  {
    path: '/designaciondocente',
    name: 'designaciondocente',
    component: () => import('../components/DesignacionDocente.vue')
  },
  {
    path: '/repaprovechamiento',
    name: 'repaprovechamiento',
    component: () => import('../components/Repaprovechamiento.vue')
  },
  {
    path: '/repbajorendimiento',
    name: 'repbajorendimiento',
    component: () => import('../components/Repbajorendimiento.vue')
  },
  {
    path: '/cambiopasper',
    name: 'cambiopasper',
    component: () => import('../components/Cambiopass.vue')
  },
  {
    path: '/asighordac',
    name: 'asighordac',
    component: () => import('../components/Asighrdac.vue')
  },
  {
    path: '/repinscripcionnuevoantiguo',
    name: 'repinscripcionnuevoantiguo',
    component: () => import('../components/Rep.inscnuevoantiguo.vue')
  },
  {
    path: '/repinscripcionsinobs',
    name: 'repinscripcionsinobs',
    component: () => import('../components/RepInscripcionSinObs.vue')
  },
  {
    path: '/preconvalidacion',
    name: 'preconvalidacion',
    component: () => import('../components/Preconvalidacion.vue')
  },
  {
    path: '/prehomologacion',
    name: 'prehomologacion',
    component: () => import('../components/Prehomologacion.vue')
  },
  {
    path: '/repinsmora',
    name: 'repinsmora',
    component: () => import('../components/Repinscritosmora.vue')
  },
  {
    path: '/repinsmoranac',
    name: 'repinsmoranac',
    component: () => import('../components/Repinscritosmoranac.vue')
  },
  {
    path: '/biometriocosuni',
    name: 'biometriocosuni',
    component: () => import('../components/Biometricos.vue')
  },
  {
    path: '/repestcontomasinpagos',
    name: 'repestcontomasinpagos',
    component: () => import('../components/Repestcontomasinpagos.vue')
  },
  {
    path: '/repinscripcionrc',
    name: 'repinscripcionrc',
    component: () => import('../components/Repinscripcionrc.vue')
  },
  {
    path: '/prehomologaciondar',
    name: 'prehomologaciondar',
    component: () => import('../components/PrehomologacionDAR.vue')
  },
  {
    path: '/convalidacion',
    name: 'convalidacion',
    component: () => import('../components/Convalidacion.vue')
  },
  {
    path: '/caleneco',
    name: 'caleneco',
    component: () => import('../components/Calendario_economico.vue')
  },
  {
    path: '/componentesys',
    name: 'componentesys',
    component: () => import('../components/Componentesys.vue')
  },
  {
    path: '/cuadrodesignacionvr',
    name: 'cuadrodesignacionvr',
    component: () => import('../components/CuadroDesignacionVR.vue')
  },
  {
    path: '/cuadrodesignacioncoord',
    name: 'cuadrodesignacioncoord',
    component: () => import('../components/CuadroDesignacionCoord.vue')
  },
  {
    path: '/cuadrodesignaciondac',
    name: 'cuadrodesignaciondac',
    component: () => import('../components/CuadroDesignacionDAC.vue')
  },
  {
    path: '/equivalencia',
    name: 'equivalencias',
    component: () => import('../components/EquivalenciaMateriasHom.vue')
  },
  {
    path: '/molinetest',
    name: 'molinetest',
    component: () => import('../components/MolineteEstudiantes.vue')
  },
  {
    path: '/molinetestx',
    name: 'molinetestx',
    component: () => import('../components/MolineteEstudiantesx.vue')
  },
  {
    path: '/diat',
    name: 'diat',
    component: () => import('../components/Diat.vue')
  },
  {
    path: '/inscripciondar',
    name: 'inscripciondar',
    component: () => import('../components/Inscrip_dar.vue')
  },
  {
    path: '/repbajacademica',
    name: 'repbajacademica',
    component: () => import('../components/RepBaja_Academica.vue')
  },
  {
    path: '/certificadonotas',
    name: 'certificadonotas',
    component: () => import('../components/CertificadoNotas.vue')
  },
  {
    path: '/seguimientoestudiantil',
    name: 'seguimientoestudiantil',
    component: () => import('../components/SeguimientoEstudiantil.vue')
  },
  {
    path: '/congresocood',
    name: 'congresocood',
    component: () => import('../components/Congresoscoord.vue')
  },
  {
    path: '/molinetestdbe',
    name: 'molinetestdbe',
    component: () => import('../components/Molinetedbe.vue')
  },
  {
    path: '/repinscnueant',
    name: 'repinscnueant',
    component: () => import('../components/Repinsnueant.vue')
  },
  {
    path: '/actasnotasdar',
    name: 'actasnotasdar',
    component: () => import('../components/ActasNotasDAR.vue')
  },
  {
    path: '/molinetestdaf',
    name: 'molinetestdaf',
    component: () => import('../components/MolineteEstDaf.vue')
  },
  {
    path: '/molinetesttodos',
    name: 'molinetesttodos',
    component: () => import('../components/MolineteEstTODOS.vue')
  },
  {
    path: '/molineteper',
    name: 'molineteper',
    component: () => import('../components/MolinetePersonal.vue')
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import('../components/Personal.vue')
  },
  {
    path: '/cuadrodesignaciongeneral',
    name: 'cuadrodesignaciongeneral',
    component: () => import('../components/CuadroDesignacionGeneral.vue')
  },
  {
    path: '/prospecto',
    name: 'prospecto',
    component: () => import('../components/Prospecto.vue')
  },
  {
    path: '/prospectoami',
    name: 'prospectoami',
    component: () => import('../components/ProspectoAMI.vue')
  },
  {
    path: '/ejecutivousuario',
    name: 'ejecutivousuario',
    component: () => import('../components/EjecutivoUsuario.vue')
  },
  {
    path: '/planinput',
    name: 'planinput',
    component: () => import('../components/PlanInput.vue')
  },
  {
    path: '/inputs',
    name: 'inputs',
    component: () => import('../components/Inputs.vue')
  },
  {
    path: '/crm1repdpm',
    name: 'crm1repdpm',
    component: () => import('../components/Crmrep1.vue')
  },
  {
    path: '/crm2repdpm',
    name: 'crm2repdpm',
    component: () => import('../components/Crmrep2.vue')
  },
  {
    path: '/crm3repdpm',
    name: 'crm3repdpm',
    component: () => import('../components/Crmrep3.vue')
  },
  {
    path: '/crm4repdpm',
    name: 'crm4repdpm',
    component: () => import('../components/Crmrep4.vue')
  },
  {
    path: '/crm5repdpm',
    name: 'crm5repdpm',
    component: () => import('../components/Crmrep5.vue')
  },
  {
    path: '/crm6repdpm',
    name: 'crm6repdpm',
    component: () => import('../components/Crmrep6.vue')
  },
  {
    path: '/crm7repdpm',
    name: 'crm7repdpm',
    component: () => import('../components/Crmrep7.vue')
  },
  {
    path: '/crm8repdpm',
    name: 'crm8repdpm',
    component: () => import('../components/Crmrep8.vue')
  },
  {
    path: '/crm1repdpmnac',
    name: 'crm1repdpmnac',
    component: () => import('../components/Crmrep1nac.vue')
  },
  {
    path: '/crm2repdpmnac',
    name: 'crm2repdpmnac',
    component: () => import('../components/Crmrep2nac.vue')
  },
  {
    path: '/crm3repdpmnac',
    name: 'crm3repdpmnac',
    component: () => import('../components/Crmrep3nac.vue')
  },
  {
    path: '/crm4repdpmnac',
    name: 'crm4repdpmnac',
    component: () => import('../components/Crmrep4nac.vue')
  },
  {
    path: '/crm5repdpmnac',
    name: 'crm5repdpmnac',
    component: () => import('../components/Crmrep5nac.vue')
  },
  {
    path: '/crm6repdpmnac',
    name: 'crm6repdpmnac',
    component: () => import('../components/Crmrep6nac.vue')
  },
  {
    path: '/crm7repdpmnac',
    name: 'crm7repdpmnac',
    component: () => import('../components/Crmrep7nac.vue')
  },
  {
    path: '/crm8repdpmnac',
    name: 'crm8repdpmnac',
    component: () => import('../components/Crmrep8nac.vue')
  },
  {
    path: '/reservaequipoadministrativo',
    name: 'reservaequipoadministrativo',
    component: () => import('../components/ReservasAdministrativos.vue')
  },
  {
    path: '/controldocente',
    name: 'controldocente',
    component: () => import('../components/ControlDocente.vue')
  },
  {
    path: '/estudiante',
    name: 'estudiante',
    component: () => import('../components/Estudiante.vue')
  },
  {
    path: '/repinscripcionmed',
    name: 'repinscripcionmed',
    component: () => import('../components/RepGruposmed.vue')
  },
  {
    path: '/estudiantedar',
    name: 'estudiantedar',
    component: () => import('../components/Estudiantedar.vue')
  },
  {
    path: '/molineteactualizar',
    name: 'molineteactualizar',
    component: () => import('../components/Molinertetodos.vue')
  },
  {
    path: '/bajaestudiante',
    name: 'bajaestudiante',
    component: () => import('../components/BajaEstudiante.vue')
  },
  {
    path: '/estudiantedbe',
    name: 'estudiantedbe',
    component: () => import('../components/EstudianteDBE.vue')
  },
  {
    path: '/admisioncrm',
    name: 'admisioncrm',
    component: () => import('../components/Amision_crm.vue')
  },
  {
    path: '/seguimiento',
    name: 'seguimiento',
    component: () => import('../components/Seguimiento.vue')
  },
  {
    path: '/bolsalid',
    name: 'bolsalid',
    component: () => import('../components/Boletasalida.vue')
  },
  {
    path: '/calendariobac',
    name: 'calendariobac',
    component: () => import('../components/CalendarioBAC.vue')
  },
  {
    path: '/repinscripcion',
    name: 'repinscripcion',
    component: () => import('../components/Repinscripcion.vue')
  },
  {
    path: '/repinscripcionlp',
    name: 'repinscripcionlp',
    component: () => import('../components/Repinscripcionlp.vue')
  },
  {
    path: '/cajainscripcioncongreso',
    name: 'cajainscripcioncongreso',
    component: () => import('../components/Caja_congresos.vue')
  },
  {
    path: '/planilladocente',
    name: 'planilladocente',
    component: () => import('../components/PlanillaDocente.vue')
  },
  {
    path: '/planpago',
    name: 'planpago',
    component: () => import('../components/Planpagos.vue')
  },
  {
    path: '/repconvalidacion',
    name: 'repconvalidacion',
    component: () => import('../components/RepConvalidacion.vue')
  },
  {
    path: '/reprompimientoprerequisitos',
    name: 'reprompimientoprerequisitos',
    component: () => import('../components/Reprompimientorequisitos.vue')
  },
  {
    path: '/reppercepcion',
    name: 'reppercepcion',
    component: () => import('../components/PercepcionEst.vue')
  },
  {
    path: '/repbac',
    name: 'repbac',
    component: () => import('../components/RepBac.vue')
  },
  {
    path: '/reprrhhlistadocentes',
    name: 'reprrhhlistadocentes',
    component: () => import('../components/RepRRHHlistadocentes.vue')
  },
  {
    path: '/repcnafseguros',
    name: 'repcnafseguros',
    component: () => import('../components/RepCNAFseguros.vue')
  },
  {
    path: '/bibliotecavirtual',
    name: 'bibliotecavirtual',
    component: () => import('../components/Biblioteca.vue')
  },
  {
    path: '/validacionasistenciarrhh',
    name: 'validacionasistenciarrhh',
    component: () => import('../components/ValidarPlanillaRRHH.vue')
  },
  {
    path: '/repconsolidadovalidacion',
    name: 'repconsolidadovalidacion',
    component: () => import('../components/ReporteValidacionDAC.vue')
  },
  {
    path: '/versioncuadrodesignacion',
    name: 'versioncuadrodesignacion',
    component: () => import('../components/VersionCuadroDesignacion.vue')
  },
  {
    path: '/accesomoodle',
    name: 'accesomoodle',
    component: () => import('../components/Moodle.vue')
  },
  {
    path: '/validacionasistencia',
    name: 'validacionasistencia',
    component: () => import('../components/ValidarPlanilla.vue')
  },
  {
    path: '/validacionasistenciadac',
    name: 'validacionasistenciadac',
    component: () => import('../components/ValidarPlanillaDAC.vue')
  },
  {
    path: '/seguimientogeneral',
    name: 'seguimientogeneral',
    component: () => import('../components/SeguimientoGeneral.vue')
  },
  {
    path: '/ingresonotas',
    name: 'ingresonotas',
    component: () => import('../components/IngresoNotas.vue')
  },
  {
    path: '/ingresonotasDAR',
    name: 'ingresonotasDAR',
    component: () => import('../components/Admactasnotasdar.vue')
  },
  {
    path: '/listaestudiante',
    name: 'listaestudiante',
    component: () => import('../components/ListaEstudiantes.vue')
  },
  {
    path: '/asistenciacoordinador',
    name: 'asistenciacoordinador',
    component: () => import('../components/AsistenciaCoordinador.vue')
  },
  {
    path: '/cambiopasswordestudiante',
    name: 'cambiopasswordestudiante',
    component: () => import('../components/CambioPasswordEstudiante.vue')
  },
  {
    path: '/certificadonotasantiguo',
    name: 'certificadonotasantiguo',
    component: () => import('../components/CertificadoNotasAntiguo.vue')
  },
  {
    path: '/repdocumentacion',
    name: 'repdocumentacion',
    component: () => import('../components/RepDocumentacion.vue')
  },
  {
    path: '/reportesrrhh',
    name: 'rep_rrhh_1',
    component: () => import('../components/ReportesRRHH.vue')
  },
  {
    path: '/horariodocente',
    name: 'horariodocente',
    component: () => import('../components/DocenteHorario.vue')
  },
  {
    path: '/homologacion',
    name: 'homologacion',
    component: () => import('../components/Homologacion.vue')
  },
  {
    path: '/notasestudiante',
    name: 'notasestudiante',
    component: () => import('../components/Estudiante/NotasEstudiante.vue')
  },
  {
    path: '/facturasestudiante',
    name: 'facturasestudiante',
    component: () => import('../components/Estudiante/FacturasEstudiante.vue')
  },
  {
    path: '/tipocambio',
    name: 'tipocambio',
    component: () => import('../components/Economico/TipoCambio.vue')
  },
  {
    // El `name` tiene que ser idéntico a unicen.componente.nombre: de ahí sale el menú.
    path: '/factorescredito',
    name: 'factorescredito',
    component: () => import('../components/Economico/FactoresCredito.vue')
  },
  {
    // Reemplazada por los módulos de IT-2026-003 (Planes económicos, Ítems de cobro, Créditos).
    path: '/catalogoitems',
    name: 'catalogoitems',
    redirect: { name: 'planeseconomicos' }
  },
  {
    // CNAF. El `name` tiene que ser idéntico a unicen.componente.nombre: de ahí sale el menú.
    path: '/planeseconomicos',
    name: 'planeseconomicos',
    component: () => import('../components/Economico/PlanesEconomicos.vue')
  },
  {
    // DAF: los planes con carreras de su sede.
    path: '/planesmisede',
    name: 'planesmisede',
    component: () => import('../components/Economico/PlanesMiSede.vue')
  },
  {
    path: '/itemscobro',
    name: 'itemscobro',
    component: () => import('../components/Economico/ItemsCobro.vue')
  },
  {
    // Horas a créditos y costo del crédito: la misma pantalla que /factorescredito.
    path: '/creditos',
    name: 'creditos',
    component: () => import('../components/Economico/FactoresCredito.vue')
  },
  {
    // El `name` tiene que ser idéntico a unicen.componente.nombre: de ahí sale el menú.
    path: '/consultaprecios',
    name: 'consultaprecios',
    component: () => import('../components/Economico/ConsultaPrecios.vue')
  },
  {
    path: '/reservaequipodocente',
    name: 'reservaequipodocente',
    component: () => import('../components/ReservasDocente.vue')
  },
  {
    path: '/repevaluaciondocentegral',
    name: 'repevaluaciondocentegral',
    component: () => import('../components/RepEval_Docente.vue')
  },
  {
    path: '/represervaequipodocente',
    name: 'represervaequipodocente',
    component: () => import('../components/RepReservasDocente.vue')
  },
  {
    path: '/egresado',
    name: 'egresado',
    component: () => import('../components/Egresado.vue')
  },
  {
    path: '/egresadodar',
    name: 'egresadodar',
    component: () => import('../components/EgresadoDAR.vue')
  },
  {
    path: '/egresadostituladossgral',
    name: 'egresadostituladossgral',
    component: () => import('../components/EgresadosTituladosSGRAL.vue')
  },
  {
    path: '/callcenter',
    name: 'callcenter',
    component: () => import('../components/Callcenter.vue')
  },
  {
    path: '/inscriptitulacion',
    name: 'inscriptitulacion',
    component: () => import('../components/InscripcionTitulacion.vue')
  },
  {
    path: '/estudiantesecgral',
    name: 'estudiantesecgral',
    component: () => import('../components/Estudiantesgral.vue')
  },
  {
    path: '/cordevaldocente',
    name: 'cordevaldocente',
    component: () => import('../components/Cordevaldoc.vue')
  },
  {
    path: '/autoevaluaciondoc',
    name: 'autoevaluaciondoc',
    component: () => import('../components/Auto_Eval_Docente.vue')
  },
  {
    path: '/tipoaula',
    name: 'tipoaula',
    component: () => import('../components/Tipoaula.vue')
  },
  {
    path: '/admisioncr',
    name: 'admisioncr',
    component: () => import('../components/AdmisionAMI.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/repmoodle',
    name: 'repmoodle',
    component: () => import('../components/ReportesMoodle.vue')
  },
  {
    path: '/reimpresionbac',
    name: 'reimpresionbac',
    component: () => import('../components/ReimpresionBAC.vue')
  },
  {
    path: '/cddrrhh',
    name: 'cddrrhh',
    component: () => import('../components/DesignacionDocenteRRHH.vue')
  },
  {
    path: '/convalidaciones',
    name: 'convalidaciones',
    component: () => import('../convalidaciones/views/ConvalidacionesIndex.vue')
  },
  {
    path: '/convalidaciones/preconvalidacion',
    name: 'preconvalidacion-coordinador',
    component: () => import('../convalidaciones/views/PreconvalidacionView.vue')
  },
  {
    path: '/convalidaciones/preconvalidacion/:id',
    name: 'gestion-convalidacion',
    component: () => import('../convalidaciones/views/GestionConvalidacionView.vue'),
    props: true,
  },
  {
    path: '/convalidaciones/formal/:id',
    name: 'convalidacion-formal',
    component: () => import('../convalidaciones/views/ConvalidacionFormalView.vue')
  }
  ,

  {
    path: '/horariospersonal',
    name: 'crearhorariospersonal',
    component: () => import('../components/HorarioPersonal.vue')
  },
  {
    path: '/repasistenciapersonal',
    name: 'reportedeasistenciapersonal',
    component: () => import('../components/ReporteAsistenciaPersonal.vue')
  },
  {
    path: '/repprospectobruto',
    name: 'repprospectobruto',
    component: () => import('../components/ReporteProspectoBruto.vue')
  },
  {
    path: '/repseguimientoejecutivos',
    name: 'repseguimientoejecutivos',
    component: () => import('../components/ReporteSeguimientoEjecutivos.vue')
  },
  {
    // `name` = `unicen.componente.nombre` (migración
    // 2026-09-25-economico-menu-reporte-becados.sql): App.vue navega por nombre.
    path: '/repbecados',
    name: 'repbecados',
    component: () => import('../components/ReporteBecados.vue')
  },
  {
    // `name` = `unicen.componente.nombre` (migración
    // 2026-10-14-menu-perfil-docente.sql): App.vue navega por nombre.
    // Solo SUPER y SECGRAL; el backend lo exige además por su cuenta.
    path: '/perfildocente',
    name: 'perfildocente',
    component: () => import('../components/PerfilDocente.vue')
  },
  {
    // `name` = `unicen.componente.nombre` (migración
    // 2026-10-14-menu-certificaciones-judiciales.sql): App.vue navega por nombre.
    // Solo SUPER y SECGRAL; el backend lo exige además por su cuenta.
    path: '/certificacionesjudiciales',
    name: 'certificacionesjudiciales',
    component: () => import('../components/CertificacionesJudiciales.vue')
  },
  {
    // `name` = `unicen.componente.nombre` (migración
    // 2026-10-02-menu-rep-promedios-estudiante.sql): App.vue navega por nombre.
    path: '/reppromediosestudiante',
    name: 'reppromediosestudiante',
    component: () => import('../components/ReportePromediosEstudiante.vue')
  },
  {
    // El `name` tiene que ser exactamente el `nombre` del ítem de menú que
    // devuelve `seiko_autlist`, porque App.vue pinta cada ítem con
    // `:to="{ name: item.nombre }"`.
    path: '/gestionaccesos',
    name: 'gestionaccesos',
    component: () => import('../components/Accesos/GestionAccesos.vue')
  },
  {
   
    path: '/tituladosdar',
    name: 'tituladosdar',
    component: () => import('../components/TituladosDAR.vue')
  },
  {
   
    path: '/rephorariosnacional',
    name: 'rephorariosnacional',
    component: () => import('../components/RephrdacNal.vue')
  },
  
  {
   
    path: '/inscripciontfgdar',
    name: 'inscripciontfgdar',
    component: () => import('../components/InscripcionTFGDAR.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let hasSession = false;
  try {
    hasSession = !!JSON.parse(sessionStorage.getItem('session'));
  } catch (e) {
    hasSession = false;
  }

  if (to.name !== from.name) {
    store.commit('setRouteLoading', true);
  }

  if (to.path !== '/login' && !hasSession) {
    next('/login');
  } else if (to.path === '/login' && hasSession) {
    next('/');
  } else {
    next();
  }
})

router.afterEach(() => {
  store.commit('setRouteLoading', false);
})

router.onError(() => {
  store.commit('setRouteLoading', false);
})

export default router
